module.exports = __webpack_public_path__ + "img/calendar.9a823d8f.png";